import { render, staticRenderFns } from "./manageBankAccount.vue?vue&type=template&id=70a9d7ec&scoped=true&"
import script from "./manageBankAccount.vue?vue&type=script&setup=true&lang=js&"
export * from "./manageBankAccount.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./manageBankAccount.vue?vue&type=style&index=0&id=70a9d7ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a9d7ec",
  null
  
)

export default component.exports